export default __webpack_public_path__ + "static/media/HoochBooch_Imagebackground.4bd74d45.gif";